

export const category1 = {
  award: { id: 1, name: "Academy Awards" },
  category: {
    id: 1,
    name: "Best Picture",
    forSeries: false,
    forMovies: true,
    overview: "Honors the year's most exceptional film since 1927.",
  },
  nominees: [
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 6748,
        name: "Philomena",
        tvdbScore: "philomena",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "205220", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: false,
      movie: {
        tvdbId: 3777,
        name: "Munich",
        tvdbScore: "munich",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2005",
        tmdbId: { id: "612", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: false,
      movie: {
        tvdbId: 2094,
        name: "Finding Neverland",
        tvdbScore: "finding-neverland",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "866", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2002",
      isWinner: false,
      movie: {
        tvdbId: 3374,
        name: "In the Bedroom",
        tvdbScore: "in-the-bedroom",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "1999", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1999",
      isWinner: false,
      movie: {
        tvdbId: 4204,
        name: "Elizabeth",
        tvdbScore: "elizabeth",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1998",
        tmdbId: { id: "4518", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1994",
      isWinner: false,
      movie: {
        tvdbId: 4469,
        name: "The Remains of the Day",
        tvdbScore: "the-remains-of-the-day",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1993",
        tmdbId: { id: "1245", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1990",
      isWinner: false,
      movie: {
        tvdbId: 2955,
        name: "Field of Dreams",
        tvdbScore: "field-of-dreams",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1989",
        tmdbId: { id: "2323", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1989",
      isWinner: false,
      movie: {
        tvdbId: 8774,
        name: "The Accidental Tourist",
        tvdbScore: "the-accidental-tourist",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1988",
        tmdbId: { id: "31052", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1989",
      isWinner: false,
      movie: {
        tvdbId: 3502,
        name: "Mississippi Burning",
        tvdbScore: "mississippi-burning",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1988",
        tmdbId: { id: "1632", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1988",
      isWinner: false,
      movie: {
        tvdbId: 7827,
        name: "Hope and Glory",
        tvdbScore: "hope-and-glory",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1987",
        tmdbId: { id: "32054", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1986",
      isWinner: false,
      movie: {
        tvdbId: 13651,
        name: "Kiss of the Spider Woman",
        tvdbScore: "kiss-of-the-spider-woman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1985",
        tmdbId: { id: "11703", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1984",
      isWinner: false,
      movie: {
        tvdbId: 20206,
        name: "Tender Mercies",
        tvdbScore: "tender-mercies",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1983",
        tmdbId: { id: "42121", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1980",
      isWinner: false,
      movie: {
        tvdbId: 12589,
        name: "Norma Rae",
        tvdbScore: "norma-rae",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1979",
        tmdbId: { id: "40842", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1979",
      isWinner: false,
      movie: {
        tvdbId: 21629,
        name: "An Unmarried Woman",
        tvdbScore: "an-unmarried-woman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1978",
        tmdbId: { id: "38731", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1975",
      isWinner: false,
      movie: {
        tvdbId: 12438,
        name: "Lenny",
        tvdbScore: "lenny",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1974",
        tmdbId: { id: "27094", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1974",
      isWinner: false,
      movie: {
        tvdbId: 60354,
        name: "A Touch of Class",
        tvdbScore: "a-touch-of-class",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1973",
        tmdbId: { id: "42458", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1973",
      isWinner: false,
      movie: {
        tvdbId: 31171,
        name: "Sounder",
        tvdbScore: "sounder",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1972",
        tmdbId: { id: "42489", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1972",
      isWinner: false,
      movie: {
        tvdbId: 5476,
        name: "Fiddler on the Roof",
        tvdbScore: "fiddler-on-the-roof",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1971",
        tmdbId: { id: "14811", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1972",
      isWinner: false,
      movie: {
        tvdbId: 64204,
        name: "Nicholas and Alexandra",
        tvdbScore: "nicholas-and-alexandra",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1971",
        tmdbId: { id: "38646", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1971",
      isWinner: false,
      movie: {
        tvdbId: 3566,
        name: "Airport",
        tvdbScore: "airport",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1970",
        tmdbId: { id: "10671", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1971",
      isWinner: false,
      movie: {
        tvdbId: 7762,
        name: "Love Story",
        tvdbScore: "love-story",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1970",
        tmdbId: { id: "9062", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1970",
      isWinner: false,
      movie: {
        tvdbId: 14323,
        name: "Anne of the Thousand Days",
        tvdbScore: "anne-of-the-thousand-days",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1969",
        tmdbId: { id: "22522", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1966",
      isWinner: false,
      movie: {
        tvdbId: 31422,
        name: "Ship of Fools",
        tvdbScore: "ship-of-fools",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1965",
        tmdbId: { id: "30080", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1965",
      isWinner: false,
      movie: {
        tvdbId: 13826,
        name: "Becket",
        tvdbScore: "becket",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1964",
        tmdbId: { id: "15421", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1965",
      isWinner: false,
      movie: {
        tvdbId: 3060,
        name: "Zorba the Greek",
        tvdbScore: "zorba-the-greek",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1964",
        tmdbId: { id: "10604", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1964",
      isWinner: false,
      movie: {
        tvdbId: 4613,
        name: "Cleopatra",
        tvdbScore: "cleopatra",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1963",
        tmdbId: { id: "8095", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1963",
      isWinner: false,
      movie: {
        tvdbId: 3852,
        name: "The Longest Day",
        tvdbScore: "the-longest-day",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1962",
        tmdbId: { id: "9289", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1963",
      isWinner: false,
      movie: {
        tvdbId: 4372,
        name: "Mutiny on the Bounty",
        tvdbScore: "mutiny-on-the-bounty",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1962",
        tmdbId: { id: "11085", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 6,
        name: "A Star is Born",
        tvdbScore: "a-star-is-born",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "332562", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 389,
        name: "The Wolf of Wall Street",
        tvdbScore: "the-wolf-of-wall-street",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "106646", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 2,
        name: "Bohemian Rhapsody",
        tvdbScore: "bohemian-rhapsody",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "424694", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1967",
      isWinner: false,
      movie: {
        tvdbId: 7021,
        name: "Who's Afraid of Virginia Woolf?",
        tvdbScore: "whos-afraid-of-virginia-woolf",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1966",
        tmdbId: { id: "396", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2004",
      isWinner: true,
      movie: {
        tvdbId: 74,
        name: "The Lord of the Rings: The Return of the King",
        tvdbScore: "the-lord-of-the-rings-the-return-of-the-king",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
        tmdbId: { id: "122", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1985",
      isWinner: false,
      movie: {
        tvdbId: 13148,
        name: "A Soldier's Story",
        tvdbScore: "a-soldiers-story",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1984",
        tmdbId: { id: "26522", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: false,
      movie: {
        tvdbId: 2971,
        name: "Ray",
        tvdbScore: "ray",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "1677", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1987",
      isWinner: false,
      movie: {
        tvdbId: 5449,
        name: "A Room with a View",
        tvdbScore: "a-room-with-a-view",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1985",
        tmdbId: { id: "11257", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1984",
      isWinner: false,
      movie: {
        tvdbId: 2471,
        name: "The Right Stuff",
        tvdbScore: "the-right-stuff",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1984",
        tmdbId: { id: "9549", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1964",
      isWinner: false,
      movie: {
        tvdbId: 3812,
        name: "How the West Was Won",
        tvdbScore: "how-the-west-was-won",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1962",
        tmdbId: { id: "11897", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1963",
      isWinner: false,
      movie: {
        tvdbId: 16085,
        name: "The Music Man",
        tvdbScore: "the-music-man",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1962",
        tmdbId: { id: "13671", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 774,
        name: "Darkest Hour",
        tvdbScore: "darkest-hour",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "399404", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 1181,
        name: "Hugo",
        tvdbScore: "hugo",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "44826", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1996",
      isWinner: true,
      movie: {
        tvdbId: 703,
        name: "Braveheart",
        tvdbScore: "braveheart",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1995",
        tmdbId: { id: "197", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 14156,
        name: "The Irishman",
        tvdbScore: "the-irishman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "398978", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1967",
      isWinner: false,
      movie: {
        tvdbId: 16233,
        name: "The Russians Are Coming, the Russians Are Coming",
        tvdbScore: "the-russians-are-coming-the-russians-are-coming",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1966",
        tmdbId: { id: "31918", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1967",
      isWinner: true,
      movie: {
        tvdbId: 4816,
        name: "A Man for All Seasons",
        tvdbScore: "a-man-for-all-seasons",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1966",
        tmdbId: { id: "874", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1963",
      isWinner: false,
      movie: {
        tvdbId: 4677,
        name: "To Kill a Mockingbird",
        tvdbScore: "to-kill-a-mockingbird",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1962",
        tmdbId: { id: "595", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 94,
        name: "Vice",
        tvdbScore: "vice",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "429197", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1969",
      isWinner: false,
      movie: {
        tvdbId: 9123,
        name: "Funny Girl",
        tvdbScore: "funny-girl",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1968",
        tmdbId: { id: "16085", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 7020,
        name: "Precious",
        tvdbScore: "precious",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "25793", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1984",
      isWinner: false,
      movie: {
        tvdbId: 7609,
        name: "The Big Chill",
        tvdbScore: "the-big-chill",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1983",
        tmdbId: { id: "12560", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1987",
      isWinner: false,
      movie: {
        tvdbId: 8726,
        name: "Children of a Lesser God",
        tvdbScore: "children-of-a-lesser-god",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1986",
        tmdbId: { id: "1890", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1990",
      isWinner: false,
      movie: {
        tvdbId: 5650,
        name: "My Left Foot: The Story of Christy Brown",
        tvdbScore: "my-left-foot-the-story-of-christy-brown",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1989",
        tmdbId: { id: "10161", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1994",
      isWinner: false,
      movie: {
        tvdbId: 3654,
        name: "In the Name of the Father",
        tvdbScore: "in-the-name-of-the-father",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1993",
        tmdbId: { id: "7984", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 798,
        name: "Phantom Thread",
        tvdbScore: "phantom-thread",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "400617", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1989",
      isWinner: false,
      movie: {
        tvdbId: 2275,
        name: "Working Girl",
        tvdbScore: "working-girl",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1988",
        tmdbId: { id: "3525", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1979",
      isWinner: true,
      movie: {
        tvdbId: 1619,
        name: "The Deer Hunter",
        tvdbScore: "the-deer-hunter",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1978",
        tmdbId: { id: "11778", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1988",
      isWinner: false,
      movie: {
        tvdbId: 6064,
        name: "Moonstruck",
        tvdbScore: "moonstruck",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1987",
        tmdbId: { id: "2039", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1976",
      isWinner: false,
      movie: {
        tvdbId: 2956,
        name: "Dog Day Afternoon",
        tvdbScore: "dog-day-afternoon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1975",
        tmdbId: { id: "968", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1985",
      isWinner: false,
      movie: {
        tvdbId: 6557,
        name: "A Passage to India",
        tvdbScore: "a-passage-to-india",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1984",
        tmdbId: { id: "15927", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1984",
      isWinner: false,
      movie: {
        tvdbId: 39690,
        name: "The Dresser",
        tvdbScore: "the-dresser-1983",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1983",
        tmdbId: { id: "42122", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1982",
      isWinner: true,
      movie: {
        tvdbId: 6623,
        name: "Chariots of Fire",
        tvdbScore: "chariots-of-fire",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1981",
        tmdbId: { id: "9443", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1973",
      isWinner: false,
      movie: {
        tvdbId: 10812,
        name: "Utvandrarna",
        tvdbScore: "the-emigrants",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1971",
        tmdbId: { id: "40732", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1974",
      isWinner: false,
      movie: {
        tvdbId: 5811,
        name: "Cries and Whispers",
        tvdbScore: "cries-and-whispers",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1972",
        tmdbId: { id: "10238", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1969",
      isWinner: false,
      movie: {
        tvdbId: 4394,
        name: "Romeo and Juliet",
        tvdbScore: "romeo-and-juliet",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1968",
        tmdbId: { id: "6003", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1967",
      isWinner: false,
      movie: {
        tvdbId: 10176,
        name: "Alfie",
        tvdbScore: "alfie-1966",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1966",
        tmdbId: { id: "15598", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1966",
      isWinner: false,
      movie: {
        tvdbId: 28210,
        name: "Darling",
        tvdbScore: "darling",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1965",
        tmdbId: { id: "24134", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 2511,
        name: "War Horse",
        tvdbScore: "war-horse",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "57212", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1971",
      isWinner: true,
      movie: {
        tvdbId: 2502,
        name: "Patton",
        tvdbScore: "patton",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1970",
        tmdbId: { id: "11202", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1975",
      isWinner: false,
      movie: {
        tvdbId: 4324,
        name: "The Conversation",
        tvdbScore: "the-conversation",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1974",
        tmdbId: { id: "592", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1968",
      isWinner: false,
      movie: {
        tvdbId: 5468,
        name: "Guess Who's Coming to Dinner",
        tvdbScore: "guess-whos-coming-to-dinner",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1967",
        tmdbId: { id: "1879", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1969",
      isWinner: false,
      movie: {
        tvdbId: 7459,
        name: "The Lion in Winter",
        tvdbScore: "the-lion-in-winter",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1968",
        tmdbId: { id: "18988", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1980",
      isWinner: false,
      movie: {
        tvdbId: 7981,
        name: "All That Jazz",
        tvdbScore: "all-that-jazz",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1979",
        tmdbId: { id: "16858", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1972",
      isWinner: true,
      movie: {
        tvdbId: 2573,
        name: "The French Connection",
        tvdbScore: "the-french-connection",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1971",
        tmdbId: { id: "1051", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1970",
      isWinner: true,
      movie: {
        tvdbId: 2098,
        name: "Midnight Cowboy",
        tvdbScore: "midnight-cowboy",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1969",
        tmdbId: { id: "3116", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 2010,
        name: "Midnight in Paris",
        tvdbScore: "midnight-in-paris",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "59436", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1982",
      isWinner: false,
      movie: {
        tvdbId: 5356,
        name: "On Golden Pond",
        tvdbScore: "on-golden-pond",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1981",
        tmdbId: { id: "11816", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1981",
      isWinner: false,
      movie: {
        tvdbId: 1303,
        name: "Raging Bull",
        tvdbScore: "raging-bull",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1980",
        tmdbId: { id: "1578", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1981",
      isWinner: true,
      movie: {
        tvdbId: 6823,
        name: "Ordinary People",
        tvdbScore: "ordinary-people",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1980",
        tmdbId: { id: "16619", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1963",
      isWinner: true,
      movie: {
        tvdbId: 2466,
        name: "Lawrence of Arabia",
        tvdbScore: "lawrence-of-arabia",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1962",
        tmdbId: { id: "947", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1964",
      isWinner: true,
      movie: {
        tvdbId: 4954,
        name: "Tom Jones",
        tvdbScore: "tom-jones",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1963",
        tmdbId: { id: "5769", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1973",
      isWinner: false,
      movie: {
        tvdbId: 9457,
        name: "Cabaret",
        tvdbScore: "cabaret",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1972",
        tmdbId: { id: "10784", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1969",
      isWinner: true,
      movie: {
        tvdbId: 6941,
        name: "Oliver!",
        tvdbScore: "oliver",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1968",
        tmdbId: { id: "17917", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1966",
      isWinner: true,
      movie: {
        tvdbId: 1600,
        name: "The Sound of Music",
        tvdbScore: "the-sound-of-music",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1965",
        tmdbId: { id: "15121", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1965",
      isWinner: true,
      movie: {
        tvdbId: 4577,
        name: "My Fair Lady",
        tvdbScore: "my-fair-lady",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1964",
        tmdbId: { id: "11113", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 2538,
        name: "Zero Dark Thirty",
        tvdbScore: "zero-dark-thirty",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "97630", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2001",
      isWinner: false,
      movie: {
        tvdbId: 3435,
        name: "Chocolat",
        tvdbScore: "chocolat",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2000",
        tmdbId: { id: "392", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1999",
      isWinner: true,
      movie: {
        tvdbId: 2259,
        name: "Shakespeare in Love",
        tvdbScore: "shakespeare-in-love",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1998",
        tmdbId: { id: "1934", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 7,
        name: "The Favourite",
        tvdbScore: "the-favourite",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "375262", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 3790,
        name: "An Education",
        tvdbScore: "an-education",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "24684", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 792,
        name: "American Sniper",
        tvdbScore: "american-sniper",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "190859", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1979",
      isWinner: false,
      movie: {
        tvdbId: 9467,
        name: "Coming Home",
        tvdbScore: "coming-home",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1978",
        tmdbId: { id: "31657", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 4638,
        name: "Nebraska",
        tvdbScore: "nebraska",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "129670", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1993",
      isWinner: false,
      movie: {
        tvdbId: 1668,
        name: "A Few Good Men",
        tvdbScore: "a-few-good-men",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1992",
        tmdbId: { id: "881", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1998",
      isWinner: false,
      movie: {
        tvdbId: 2127,
        name: "As Good as It Gets",
        tvdbScore: "as-good-as-it-gets",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1997",
        tmdbId: { id: "2898", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 192,
        name: "Lion",
        tvdbScore: "lion",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "334543", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1983",
      isWinner: false,
      movie: {
        tvdbId: 10306,
        name: "The Verdict",
        tvdbScore: "the-verdict",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1982",
        tmdbId: { id: "24226", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2000",
      isWinner: false,
      movie: {
        tvdbId: 6686,
        name: "The Cider House Rules",
        tvdbScore: "the-cider-house-rules",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1999",
        tmdbId: { id: "1715", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1990",
      isWinner: true,
      movie: {
        tvdbId: 4565,
        name: "Driving Miss Daisy",
        tvdbScore: "driving-miss-daisy",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1989",
        tmdbId: { id: "403", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: false,
      movie: {
        tvdbId: 4088,
        name: "Michael Clayton",
        tvdbScore: "michael-clayton",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
        tmdbId: { id: "4566", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 1321,
        name: "Captain Phillips",
        tvdbScore: "captain-phillips",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "109424", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1995",
      isWinner: true,
      movie: {
        tvdbId: 294,
        name: "Forrest Gump",
        tvdbScore: "forrest-gump",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1994",
        tmdbId: { id: "13", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1997",
      isWinner: false,
      movie: {
        tvdbId: 1081,
        name: "Jerry Maguire",
        tvdbScore: "jerry-maguire",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1996",
      },
    },
    {
      awardYear: "1991",
      isWinner: false,
      movie: {
        tvdbId: 4382,
        name: "Awakenings",
        tvdbScore: "awakenings",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1990",
        tmdbId: { id: "11005", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1982",
      isWinner: false,
      movie: {
        tvdbId: 8809,
        name: "Reds",
        tvdbScore: "reds",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1981",
        tmdbId: { id: "18254", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: false,
      movie: {
        tvdbId: 5735,
        name: "Capote",
        tvdbScore: "capote",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2005",
        tmdbId: { id: "398", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1998",
      isWinner: false,
      movie: {
        tvdbId: 949,
        name: "Good Will Hunting",
        tvdbScore: "good-will-hunting",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1997",
        tmdbId: { id: "489", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1977",
      isWinner: false,
      movie: {
        tvdbId: 529,
        name: "All the President's Men",
        tvdbScore: "all-the-presidents-men",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1976",
        tmdbId: { id: "891", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1966",
      isWinner: false,
      movie: {
        tvdbId: 100361,
        name: "A Thousand Clowns",
        tvdbScore: "a-thousand-clowns",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1965",
        tmdbId: { id: "42731", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1966",
      isWinner: false,
      movie: {
        tvdbId: 4864,
        name: "Doctor Zhivago",
        tvdbScore: "doctor-zhivago",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1965",
        tmdbId: { id: "907", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 620,
        name: "Lady Bird",
        tvdbScore: "lady-bird",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "391713", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 383,
        name: "Mad Max: Fury Road",
        tvdbScore: "mad-max-fury-road",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "76341", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 3913,
        name: "Fences",
        tvdbScore: "fences",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "393457", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2002",
      isWinner: false,
      movie: {
        tvdbId: 3139,
        name: "Gosford Park",
        tvdbScore: "gosford-park",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "5279", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1995",
      isWinner: false,
      movie: {
        tvdbId: 3370,
        name: "Quiz Show",
        tvdbScore: "quiz-show",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1994",
        tmdbId: { id: "11450", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1970",
      isWinner: false,
      movie: {
        tvdbId: 9512,
        name: "Hello, Dolly!",
        tvdbScore: "hello-dolly",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1969",
        tmdbId: { id: "14030", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 826,
        name: "Selma",
        tvdbScore: "selma",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "273895", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2002",
      isWinner: true,
      movie: {
        tvdbId: 1472,
        name: "A Beautiful Mind",
        tvdbScore: "a-beautiful-mind",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "453", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1996",
      isWinner: false,
      movie: {
        tvdbId: 282,
        name: "Apollo 13",
        tvdbScore: "apollo-13",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1995",
        tmdbId: { id: "568", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1983",
      isWinner: true,
      movie: {
        tvdbId: 2510,
        name: "Gandhi",
        tvdbScore: "gandhi",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1982",
        tmdbId: { id: "783", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1967",
      isWinner: false,
      movie: {
        tvdbId: 10872,
        name: "The Sand Pebbles",
        tvdbScore: "the-sand-pebbles",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1966",
        tmdbId: { id: "5923", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1968",
      isWinner: false,
      movie: {
        tvdbId: 11063,
        name: "Doctor Dolittle",
        tvdbScore: "doctor-dolittle-1967",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1967",
        tmdbId: { id: "16081", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1997",
      isWinner: false,
      movie: {
        tvdbId: 9031,
        name: "Shine",
        tvdbScore: "shine",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1996",
        tmdbId: { id: "7863", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1964",
      isWinner: false,
      movie: {
        tvdbId: 38713,
        name: "America America",
        tvdbScore: "america-america",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1963",
        tmdbId: { id: "47249", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1965",
      isWinner: false,
      movie: {
        tvdbId: 1657,
        name: "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
        tvdbScore:
          "dr-strangelove-or-how-i-learned-to-stop-worrying-and-love-the-bomb",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1964",
        tmdbId: { id: "935", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1996",
      isWinner: false,
      movie: {
        tvdbId: 3593,
        name: "Sense and Sensibility",
        tvdbScore: "sense-and-sensibility",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1995",
        tmdbId: { id: "4584", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 1922,
        name: "Winter's Bone",
        tvdbScore: "winters-bone",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "39013", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: false,
      movie: {
        tvdbId: 4551,
        name: "Sideways",
        tvdbScore: "sideways",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "9675", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2009",
      isWinner: false,
      movie: {
        tvdbId: 2668,
        name: "Frost/Nixon",
        tvdbScore: "frostnixon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "11499", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 255,
        name: "Hidden Figures",
        tvdbScore: "hidden-figures",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "381284", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2000",
      isWinner: false,
      movie: {
        tvdbId: 947,
        name: "The Sixth Sense",
        tvdbScore: "the-sixth-sense",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1999",
        tmdbId: { id: "745", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1994",
      isWinner: false,
      movie: {
        tvdbId: 1054,
        name: "The Fugitive",
        tvdbScore: "the-fugitive",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1993",
        tmdbId: { id: "5503", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1981",
      isWinner: false,
      movie: {
        tvdbId: 7087,
        name: "Coal Miner's Daughter",
        tvdbScore: "coal-miners-daughter",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1980",
        tmdbId: { id: "16769", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1987",
      isWinner: true,
      movie: {
        tvdbId: 2050,
        name: "Platoon",
        tvdbScore: "platoon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1986",
        tmdbId: { id: "792", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1990",
      isWinner: false,
      movie: {
        tvdbId: 3722,
        name: "Born on the Fourth of July",
        tvdbScore: "born-on-the-fourth-of-july",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1989",
        tmdbId: { id: "2604", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1992",
      isWinner: false,
      movie: {
        tvdbId: 2476,
        name: "JFK",
        tvdbScore: "jfk",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1991",
        tmdbId: { id: "820", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2007",
      isWinner: false,
      movie: {
        tvdbId: 4187,
        name: "Letters from Iwo Jima",
        tvdbScore: "letters-from-iwo-jima",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "1251", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1992",
      isWinner: false,
      movie: {
        tvdbId: 6237,
        name: "The Prince of Tides",
        tvdbScore: "the-prince-of-tides",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1991",
        tmdbId: { id: "10333", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 1320,
        name: "District 9",
        tvdbScore: "district-9",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "17654", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1968",
      isWinner: false,
      movie: {
        tvdbId: 2091,
        name: "The Graduate",
        tvdbScore: "the-graduate",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1967",
      },
    },
    {
      awardYear: "1978",
      isWinner: false,
      movie: {
        tvdbId: 41478,
        name: "The Turning Point",
        tvdbScore: "the-turning-point",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1977",
        tmdbId: { id: "61280", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: true,
      movie: {
        tvdbId: 207,
        name: "No Country for Old Men",
        tvdbScore: "no-country-for-old-men",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
        tmdbId: { id: "6977", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 5443,
        name: "A Serious Man",
        tvdbScore: "a-serious-man",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "12573", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 1853,
        name: "The Fighter",
        tvdbScore: "the-fighter",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "45317", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 132209,
        name: "Mank",
        tvdbScore: "mank",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "614560", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 132892,
        name: "The Trial of the Chicago 7",
        tvdbScore: "the-trial-of-the-chicago-7",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "556984", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1957",
      isWinner: false,
      movie: {
        tvdbId: 8508,
        name: "The King and I",
        tvdbScore: "the-king-and-i",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1956",
        tmdbId: { id: "16520", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 138362,
        name: "Judas and the Black Messiah",
        tvdbScore: "judas-and-the-black-messiah",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "583406", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: false,
      movie: {
        tvdbId: 2363,
        name: "Juno",
        tvdbScore: "juno",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
        tmdbId: { id: "7326", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: true,
      movie: {
        tvdbId: 32,
        name: "Green Book",
        tvdbScore: "green-book",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "490132", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1972",
      isWinner: false,
      movie: {
        tvdbId: 641,
        name: "A Clockwork Orange",
        tvdbScore: "a-clockwork-orange",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1971",
        tmdbId: { id: "185", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: true,
      movie: {
        tvdbId: 3927,
        name: "Chicago",
        tvdbScore: "chicago",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "1574", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1978",
      isWinner: false,
      movie: {
        tvdbId: 14976,
        name: "The Goodbye Girl",
        tvdbScore: "the-goodbye-girl",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1977",
        tmdbId: { id: "14741", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1991",
      isWinner: false,
      movie: {
        tvdbId: 1803,
        name: "Ghost",
        tvdbScore: "ghost",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1990",
        tmdbId: { id: "251", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: false,
      movie: {
        tvdbId: 1744,
        name: "The Aviator",
        tvdbScore: "the-aviator",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "2567", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1986",
      isWinner: false,
      movie: {
        tvdbId: 3153,
        name: "Witness",
        tvdbScore: "witness",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1985",
        tmdbId: { id: "9281", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 42625,
        name: "Jojo Rabbit",
        tvdbScore: "jojo-rabbit",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "515001", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 6507,
        name: "The Kids Are All Right",
        tvdbScore: "the-kids-are-all-right",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "39781", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 1562,
        name: "Les Misérables",
        tvdbScore: "les-miserables",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "82695", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1977",
      isWinner: false,
      movie: {
        tvdbId: 38392,
        name: "Bound for Glory",
        tvdbScore: "bound-for-glory",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1976",
        tmdbId: { id: "42232", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1971",
      isWinner: false,
      movie: {
        tvdbId: 9285,
        name: "Five Easy Pieces",
        tvdbScore: "five-easy-pieces",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1970",
        tmdbId: { id: "26617", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2007",
      isWinner: true,
      movie: {
        tvdbId: 590,
        name: "The Departed",
        tvdbScore: "the-departed",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "1422", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 1412,
        name: "127 Hours",
        tvdbScore: "127-hours",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "44115", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1974",
      isWinner: true,
      movie: {
        tvdbId: 3077,
        name: "The Sting",
        tvdbScore: "the-sting",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1973",
        tmdbId: {
          id: "9277-the-sting",
          type: 10,
          sourceName: "TheMovieDB.com",
        },
      },
    },
    {
      awardYear: "1992",
      isWinner: false,
      movie: {
        tvdbId: 5269,
        name: "Bugsy",
        tvdbScore: "bugsy",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1991",
        tmdbId: { id: "10337", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 480,
        name: "Hacksaw Ridge",
        tvdbScore: "hacksaw-ridge",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "324786", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1964",
      isWinner: false,
      movie: {
        tvdbId: 43796,
        name: "Lilies of the Field",
        tvdbScore: "lilies-of-the-field",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1963",
        tmdbId: { id: "38805", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1968",
      isWinner: true,
      movie: {
        tvdbId: 4667,
        name: "In the Heat of the Night",
        tvdbScore: "in-the-heat-of-the-night",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1967",
        tmdbId: { id: "10633", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 129,
        name: "Whiplash",
        tvdbScore: "whiplash",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "244786", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: true,
      movie: {
        tvdbId: 606,
        name: "Spotlight",
        tvdbScore: "spotlight",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "314365", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 1580,
        name: "Dallas Buyers Club",
        tvdbScore: "dallas-buyers-club",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "152532", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 1699,
        name: "American Hustle",
        tvdbScore: "american-hustle",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "168672", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 131153,
        name: "Marriage Story",
        tvdbScore: "marriage-story",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "492188", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1977",
      isWinner: false,
      movie: {
        tvdbId: 472,
        name: "Taxi Driver",
        tvdbScore: "taxi-driver",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1976",
        tmdbId: { id: "103", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2009",
      isWinner: false,
      movie: {
        tvdbId: 1934,
        name: "The Reader",
        tvdbScore: "the-reader",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "8055", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1979",
      isWinner: false,
      movie: {
        tvdbId: 6800,
        name: "Midnight Express",
        tvdbScore: "midnight-express",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1978",
        tmdbId: { id: "11327", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: false,
      movie: {
        tvdbId: 6805,
        name: "Good Night, and Good Luck.",
        tvdbScore: "good-night-and-good-luck",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2005",
        tmdbId: { id: "3291", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1969",
      isWinner: false,
      movie: {
        tvdbId: 30256,
        name: "Rachel, Rachel",
        tvdbScore: "rachel-rachel",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1968",
        tmdbId: { id: "42635", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1996",
      isWinner: false,
      movie: {
        tvdbId: 1886,
        name: "Babe",
        tvdbScore: "babe",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1995",
        tmdbId: { id: "9598", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 131600,
        name: "Nightmare Alley",
        tvdbScore: "nightmare-alley-2021",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "597208", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1976",
      isWinner: false,
      movie: {
        tvdbId: 7053,
        name: "Nashville",
        tvdbScore: "nashville",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1975",
        tmdbId: { id: "3121", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 3053,
        name: "Moneyball",
        tvdbScore: "moneyball",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "60308", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1983",
      isWinner: false,
      movie: {
        tvdbId: 9405,
        name: "Missing",
        tvdbScore: "missing",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1982",
        tmdbId: { id: "15600", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1981",
      isWinner: false,
      movie: {
        tvdbId: 4410,
        name: "The Elephant Man",
        tvdbScore: "the-elephant-man",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1980",
        tmdbId: { id: "1955", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1988",
      isWinner: true,
      movie: {
        tvdbId: 3084,
        name: "The Last Emperor",
        tvdbScore: "the-last-emperor",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1987",
        tmdbId: { id: "746", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1989",
      isWinner: false,
      movie: {
        tvdbId: 2359,
        name: "Dangerous Liaisons",
        tvdbScore: "dangerous-liaisons",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1989",
        tmdbId: { id: "859", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1995",
      isWinner: false,
      movie: {
        tvdbId: 228,
        name: "Pulp Fiction",
        tvdbScore: "pulp-fiction",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1994",
        tmdbId: { id: "680", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2004",
      isWinner: false,
      movie: {
        tvdbId: 2076,
        name: "Mystic River",
        tvdbScore: "mystic-river",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
      },
    },
    {
      awardYear: "2004",
      isWinner: false,
      movie: {
        tvdbId: 1169,
        name: "Lost in Translation",
        tvdbScore: "lost-in-translation",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
        tmdbId: { id: "153", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: true,
      movie: {
        tvdbId: 1475,
        name: "Million Dollar Baby",
        tvdbScore: "million-dollar-baby",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "70", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 2240,
        name: "The Social Network",
        tvdbScore: "the-social-network",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "37799", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 289,
        name: "Django Unchained",
        tvdbScore: "django-unchained",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
      },
    },
    {
      awardYear: "1976",
      isWinner: false,
      movie: {
        tvdbId: 3296,
        name: "Barry Lyndon",
        tvdbScore: "barry-lyndon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1975",
        tmdbId: { id: "3175", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: true,
      movie: {
        tvdbId: 627,
        name: "The King's Speech",
        tvdbScore: "the-kings-speech",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
      },
    },
    {
      awardYear: "1978",
      isWinner: false,
      movie: {
        tvdbId: 11903,
        name: "Julia",
        tvdbScore: "julia",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1977",
        tmdbId: { id: "42222", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1983",
      isWinner: false,
      movie: {
        tvdbId: 4225,
        name: "Tootsie",
        tvdbScore: "tootsie",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1982",
        tmdbId: { id: "9576", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1987",
      isWinner: false,
      movie: {
        tvdbId: 7224,
        name: "Hannah and Her Sisters",
        tvdbScore: "hannah-and-her-sisters",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1986",
        tmdbId: { id: "5143", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1985",
      isWinner: false,
      movie: {
        tvdbId: 5892,
        name: "The Killing Fields",
        tvdbScore: "the-killing-fields",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1984",
        tmdbId: { id: "625", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 453,
        name: "Three Billboards Outside Ebbing, Missouri",
        tvdbScore: "three-billboards-outside-ebbing-missouri",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "359940", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 1265,
        name: "Manchester by the Sea",
        tvdbScore: "manchester-by-the-sea",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "334541", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: true,
      movie: {
        tvdbId: 802,
        name: "12 Years a Slave",
        tvdbScore: "12-years-a-slave",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "76203", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: false,
      movie: {
        tvdbId: 1722,
        name: "There Will Be Blood",
        tvdbScore: "there-will-be-blood",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
        tmdbId: { id: "7345", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: false,
      movie: {
        tvdbId: 1457,
        name: "Brokeback Mountain",
        tvdbScore: "brokeback-mountain",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2005",
        tmdbId: { id: "142", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2007",
      isWinner: false,
      movie: {
        tvdbId: 1673,
        name: "Babel",
        tvdbScore: "babel",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "1164", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2002",
      isWinner: false,
      movie: {
        tvdbId: 1671,
        name: "Moulin Rouge!",
        tvdbScore: "moulin-rouge",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "824", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2001",
      isWinner: false,
      movie: {
        tvdbId: 2937,
        name: "Traffic",
        tvdbScore: "traffic",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2000",
        tmdbId: { id: "1900", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1997",
      isWinner: true,
      movie: {
        tvdbId: 2591,
        name: "The English Patient",
        tvdbScore: "the-english-patient",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1996",
        tmdbId: { id: "409", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1998",
      isWinner: false,
      movie: {
        tvdbId: 6880,
        name: "The Full Monty",
        tvdbScore: "the-full-monty",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1997",
        tmdbId: { id: "9427", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1997",
      isWinner: false,
      movie: {
        tvdbId: 5340,
        name: "Secrets & Lies",
        tvdbScore: "secrets-lies",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1996",
        tmdbId: { id: "11159", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1993",
      isWinner: false,
      movie: {
        tvdbId: 5351,
        name: "Howards End",
        tvdbScore: "howards-end",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1992",
        tmdbId: { id: "8293", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1991",
      isWinner: true,
      movie: {
        tvdbId: 1624,
        name: "Dances with Wolves",
        tvdbScore: "dances-with-wolves",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1990",
        tmdbId: { id: "581", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1991",
      isWinner: false,
      movie: {
        tvdbId: 380,
        name: "GoodFellas",
        tvdbScore: "goodfellas",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1990",
        tmdbId: { id: "769", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1989",
      isWinner: true,
      movie: {
        tvdbId: 1917,
        name: "Rain Man",
        tvdbScore: "rain-man",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1988",
        tmdbId: { id: "380", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1995",
      isWinner: false,
      movie: {
        tvdbId: 1933,
        name: "Four Weddings and a Funeral",
        tvdbScore: "four-weddings-and-a-funeral",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1994",
        tmdbId: { id: "712", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 1603,
        name: "True Grit",
        tvdbScore: "true-grit",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "44264", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 4501,
        name: "Beasts of the Southern Wild",
        tvdbScore: "beasts-of-the-southern-wild",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "84175", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2001",
      isWinner: false,
      movie: {
        tvdbId: 5881,
        name: "Erin Brockovich",
        tvdbScore: "erin-brockovich",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2000",
        tmdbId: { id: "462", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 5782,
        name: "Amour",
        tvdbScore: "amour",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "86837", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1993",
      isWinner: false,
      movie: {
        tvdbId: 2138,
        name: "Scent of a Woman",
        tvdbScore: "scent-of-a-woman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1992",
        tmdbId: { id: "9475", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 141397,
        name: "Sound of Metal",
        tvdbScore: "sound-of-metal",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "502033", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: true,
      movie: {
        tvdbId: 265,
        name: "Birdman",
        tvdbScore: "birdman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "194662", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 138100,
        name: "The Father",
        tvdbScore: "138100-the-father",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "600354", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2009",
      isWinner: false,
      movie: {
        tvdbId: 7234,
        name: "Milk",
        tvdbScore: "milk",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "10139", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: true,
      movie: {
        tvdbId: 2189,
        name: "The Artist",
        tvdbScore: "the-artist",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "74643", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 141474,
        name: "Minari",
        tvdbScore: "minari",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "615643", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 4559,
        name: "The Hours",
        tvdbScore: "the-hours",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "590", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 3335,
        name: "Hell or High Water",
        tvdbScore: "hell-or-high-water",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "338766", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1988",
      isWinner: false,
      movie: {
        tvdbId: 2227,
        name: "Fatal Attraction",
        tvdbScore: "fatal-attraction",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1987",
        tmdbId: { id: "10998", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 1754,
        name: "The Theory of Everything",
        tvdbScore: "the-theory-of-everything",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "266856", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: false,
      movie: {
        tvdbId: 1828,
        name: "Atonement",
        tvdbScore: "atonement",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
        tmdbId: { id: "4347", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 132904,
        name: "Promising Young Woman",
        tvdbScore: "promising-young-woman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "582014", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 12999,
        name: "Once Upon a Time... in Hollywood",
        tvdbScore: "once-upon-a-time-in-hollywood",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "466272", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1998",
      isWinner: true,
      movie: {
        tvdbId: 231,
        name: "Titanic",
        tvdbScore: "titanic",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1997",
        tmdbId: { id: "597", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1986",
      isWinner: false,
      movie: {
        tvdbId: 5364,
        name: "The Color Purple",
        tvdbScore: "the-color-purple",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1985",
        tmdbId: { id: "873", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1974",
      isWinner: false,
      movie: {
        tvdbId: 4117,
        name: "American Graffiti",
        tvdbScore: "american-graffiti",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1973",
        tmdbId: { id: "838", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: true,
      movie: {
        tvdbId: 241,
        name: "The Shape of Water",
        tvdbScore: "the-shape-of-water",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "399055", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: true,
      movie: {
        tvdbId: 776,
        name: "Moonlight",
        tvdbScore: "moonlight",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "376867", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2000",
      isWinner: true,
      movie: {
        tvdbId: 445,
        name: "American Beauty",
        tvdbScore: "american-beauty",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1999",
      },
    },
    {
      awardYear: "1993",
      isWinner: true,
      movie: {
        tvdbId: 1504,
        name: "Unforgiven",
        tvdbScore: "unforgiven",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1992",
        tmdbId: { id: "33", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1975",
      isWinner: false,
      movie: {
        tvdbId: 3750,
        name: "The Towering Inferno",
        tvdbScore: "the-towering-inferno",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1974",
        tmdbId: {
          id: "5919-the-towering-inferno",
          type: 10,
          sourceName: "TheMovieDB.com",
        },
      },
    },
    {
      awardYear: "2009",
      isWinner: true,
      movie: {
        tvdbId: 1166,
        name: "Slumdog Millionaire",
        tvdbScore: "slumdog-millionaire",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "12405", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1994",
      isWinner: false,
      movie: {
        tvdbId: 4121,
        name: "The Piano",
        tvdbScore: "the-piano",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1993",
        tmdbId: { id: "713", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 48,
        name: "Black Panther",
        tvdbScore: "black-panther",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "284054", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1980",
      isWinner: false,
      movie: {
        tvdbId: 9701,
        name: "Breaking Away",
        tvdbScore: "breaking-away",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1979",
        tmdbId: { id: "20283", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1972",
      isWinner: false,
      movie: {
        tvdbId: 7800,
        name: "The Last Picture Show",
        tvdbScore: "the-last-picture-show",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1971",
        tmdbId: { id: "25188", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2007",
      isWinner: false,
      movie: {
        tvdbId: 2649,
        name: "The Queen",
        tvdbScore: "the-queen",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "1165", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: true,
      movie: {
        tvdbId: 140648,
        name: "Nomadland",
        tvdbScore: "nomadland",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "581734", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1993",
      isWinner: false,
      movie: {
        tvdbId: 7035,
        name: "The Crying Game",
        tvdbScore: "the-crying-game",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1992",
        tmdbId: { id: "11386", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1987",
      isWinner: false,
      movie: {
        tvdbId: 3218,
        name: "The Mission",
        tvdbScore: "the-mission",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1986",
        tmdbId: { id: "11416", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1986",
      isWinner: false,
      movie: {
        tvdbId: 7286,
        name: "Prizzi's Honor",
        tvdbScore: "prizzis-honor",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1985",
        tmdbId: { id: "2075", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2001",
      isWinner: true,
      movie: {
        tvdbId: 419,
        name: "Gladiator",
        tvdbScore: "gladiator",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2000",
      },
    },
    {
      awardYear: "1974",
      isWinner: false,
      movie: {
        tvdbId: 944,
        name: "The Exorcist",
        tvdbScore: "the-exorcist",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1973",
        tmdbId: { id: "9552", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1978",
      isWinner: true,
      movie: {
        tvdbId: 3855,
        name: "Annie Hall",
        tvdbScore: "annie-hall",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1977",
        tmdbId: { id: "703", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 597,
        name: "Life of Pi",
        tvdbScore: "life-of-pi",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "87827", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1998",
      isWinner: false,
      movie: {
        tvdbId: 2234,
        name: "L.A. Confidential",
        tvdbScore: "la-confidential",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1997",
        tmdbId: { id: "2118", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1984",
      isWinner: true,
      movie: {
        tvdbId: 7095,
        name: "Terms of Endearment",
        tvdbScore: "terms-of-endearment",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1983",
        tmdbId: { id: "11050", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 4643,
        name: "The Tree of Life",
        tvdbScore: "the-tree-of-life",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "8967", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1985",
      isWinner: false,
      movie: {
        tvdbId: 15023,
        name: "Places in the Heart",
        tvdbScore: "places-in-the-heart",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1984",
        tmdbId: { id: "13681", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 132,
        name: "The Martian",
        tvdbScore: "the-martian",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "286217", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 315,
        name: "Up",
        tvdbScore: "up",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "14160", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 341,
        name: "Call Me by Your Name",
        tvdbScore: "call-me-by-your-name",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "398818", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1973",
      isWinner: true,
      movie: {
        tvdbId: 275,
        name: "The Godfather",
        tvdbScore: "the-godfather",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1972",
        tmdbId: { id: "238", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1975",
      isWinner: true,
      movie: {
        tvdbId: 780,
        name: "The Godfather: Part II",
        tvdbScore: "the-godfather-part-ii",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1974",
        tmdbId: { id: "240", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1991",
      isWinner: false,
      movie: {
        tvdbId: 2270,
        name: "The Godfather: Part III",
        tvdbScore: "the-godfather-part-iii",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1990",
      },
    },
    {
      awardYear: "1992",
      isWinner: false,
      movie: {
        tvdbId: 226,
        name: "Beauty and the Beast",
        tvdbScore: "beauty-and-the-beast",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1991",
        tmdbId: { id: "10020", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 335,
        name: "The Imitation Game",
        tvdbScore: "the-imitation-game",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "205596", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 902,
        name: "Room",
        tvdbScore: "room",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "264644", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 3148,
        name: "Lincoln",
        tvdbScore: "lincoln",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "72976", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 1082,
        name: "Bridge of Spies",
        tvdbScore: "bridge-of-spies",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "296098", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1983",
      isWinner: false,
      movie: {
        tvdbId: 758,
        name: "E.T. The Extra-Terrestrial",
        tvdbScore: "et-the-extra-terrestrial",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1982",
        tmdbId: { id: "601", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: true,
      movie: {
        tvdbId: 2627,
        name: "Argo",
        tvdbScore: "argo",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "68734", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 23,
        name: "BlacKkKlansman",
        tvdbScore: "blackkklansman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "487558", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 360,
        name: "Boyhood",
        tvdbScore: "boyhood",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "85350", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1996",
      isWinner: false,
      movie: {
        tvdbId: 7606,
        name: "Il Postino",
        tvdbScore: "the-postman-1994",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1994",
        tmdbId: { id: "11010", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1978",
      isWinner: false,
      movie: {
        tvdbId: 71,
        name: "Star Wars",
        tvdbScore: "star-wars",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1977",
        tmdbId: { id: "11", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 16,
        name: "Roma",
        tvdbScore: "roma",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "426426", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 141495,
        name: "Don't Look Up",
        tvdbScore: "dont-look-up-2021",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "646380", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 397,
        name: "Inglourious Basterds",
        tvdbScore: "inglourious-basterds",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "16869", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 6230,
        name: "Extremely Loud & Incredibly Close",
        tvdbScore: "extremely-loud-incredibly-close",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "64685", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2000",
      isWinner: false,
      movie: {
        tvdbId: 3309,
        name: "The Insider",
        tvdbScore: "the-insider",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1999",
        tmdbId: { id: "9008", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2004",
      isWinner: false,
      movie: {
        tvdbId: 6733,
        name: "Seabiscuit",
        tvdbScore: "seabiscuit",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
        tmdbId: { id: "4464", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2004",
      isWinner: false,
      movie: {
        tvdbId: 478,
        name: "Master and Commander: The Far Side of the World",
        tvdbScore: "master-and-commander-the-far-side-of-the-world",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
        tmdbId: { id: "8619", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1985",
      isWinner: true,
      movie: {
        tvdbId: 3982,
        name: "Amadeus",
        tvdbScore: "amadeus",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1984",
        tmdbId: { id: "279", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 165,
        name: "Avatar",
        tvdbScore: "avatar",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "19995", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: true,
      movie: {
        tvdbId: 1284,
        name: "The Hurt Locker",
        tvdbScore: "the-hurt-locker",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "12162", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 1579,
        name: "Up in the Air",
        tvdbScore: "up-in-the-air",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "22947", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: true,
      movie: {
        tvdbId: 1955,
        name: "Crash",
        tvdbScore: "crash",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "1640", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1999",
      isWinner: false,
      movie: {
        tvdbId: 569,
        name: "Saving Private Ryan",
        tvdbScore: "saving-private-ryan",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1998",
        tmdbId: { id: "857", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 943,
        name: "The Post",
        tvdbScore: "the-post",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "446354", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1970",
      isWinner: false,
      movie: {
        tvdbId: 1049,
        name: "Butch Cassidy and the Sundance Kid",
        tvdbScore: "butch-cassidy-and-the-sundance-kid",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1969",
        tmdbId: {
          id: "642-butch-cassidy-and-the-sundance-kid",
          type: 10,
          sourceName: "TheMovieDB.com",
        },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 336484,
        name: "TÁR",
        tvdbScore: "tar",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "817758", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2000",
      isWinner: false,
      movie: {
        tvdbId: 308,
        name: "The Green Mile",
        tvdbScore: "the-green-mile",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1999",
        tmdbId: { id: "497", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1997",
      isWinner: false,
      movie: {
        tvdbId: 1103,
        name: "Fargo",
        tvdbScore: "fargo",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1996",
        tmdbId: { id: "275", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 970,
        name: "The Help",
        tvdbScore: "the-help",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "50014", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 195090,
        name: "The Fabelmans",
        tvdbScore: "the-fabelmans",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "804095", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 16721,
        name: "Top Gun: Maverick",
        tvdbScore: "top-gun-maverick",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "361743", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1979",
      isWinner: false,
      movie: {
        tvdbId: 11034,
        name: "Heaven Can Wait",
        tvdbScore: "heaven-can-wait",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1978",
        tmdbId: { id: "12185", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 336479,
        name: "Women Talking",
        tvdbScore: "women-talking",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "777245", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 421,
        name: "The Grand Budapest Hotel",
        tvdbScore: "the-grand-budapest-hotel",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
      },
    },
    {
      awardYear: "1988",
      isWinner: false,
      movie: {
        tvdbId: 4055,
        name: "Broadcast News",
        tvdbScore: "broadcast-news",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1987",
        tmdbId: { id: "12626", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 2457,
        name: "Gangs of New York",
        tvdbScore: "gangs-of-new-york",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "3131", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1980",
      isWinner: true,
      movie: {
        tvdbId: 6217,
        name: "Kramer vs. Kramer",
        tvdbScore: "kramer-vs-kramer",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1979",
        tmdbId: { id: "12102", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 219,
        name: "Arrival",
        tvdbScore: "arrival",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "329865", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1995",
      isWinner: false,
      movie: {
        tvdbId: 190,
        name: "The Shawshank Redemption",
        tvdbScore: "the-shawshank-redemption",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1994",
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 418,
        name: "Gravity",
        tvdbScore: "gravity",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "49047", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 5483,
        name: "Avatar: The Way of Water",
        tvdbScore: "avatar-the-way-of-water",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "76600", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2009",
      isWinner: false,
      movie: {
        tvdbId: 1508,
        name: "The Curious Case of Benjamin Button",
        tvdbScore: "the-curious-case-of-benjamin-button",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "4922", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 113232,
        name: "West Side Story",
        tvdbScore: "west-side-story-2021",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "511809", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 593,
        name: "The Revenant",
        tvdbScore: "the-revenant",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "281957", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 30526,
        name: "1917",
        tvdbScore: "1917",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "530915", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 1445,
        name: "The Descendants",
        tvdbScore: "the-descendants",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "65057", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1970",
      isWinner: false,
      movie: {
        tvdbId: 8445,
        name: "Z",
        tvdbScore: "z",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1969",
        tmdbId: { id: "2721", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 175911,
        name: "The Banshees of Inisherin",
        tvdbScore: "the-banshees-of-inisheer",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "674324", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 721,
        name: "Black Swan",
        tvdbScore: "black-swan",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "44214", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 1411,
        name: "The Blind Side",
        tvdbScore: "the-blind-side",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "22881", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1980",
      isWinner: false,
      movie: {
        tvdbId: 1077,
        name: "Apocalypse Now",
        tvdbScore: "apocalypse-now",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1979",
        tmdbId: { id: "28", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1999",
      isWinner: false,
      movie: {
        tvdbId: 604,
        name: "La vita è bella",
        tvdbScore: "life-is-beautiful",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1997",
        tmdbId: { id: "637", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1990",
      isWinner: false,
      movie: {
        tvdbId: 728,
        name: "Dead Poets Society",
        tvdbScore: "dead-poets-society",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1989",
        tmdbId: { id: "207", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1994",
      isWinner: true,
      movie: {
        tvdbId: 223,
        name: "Schindler's List",
        tvdbScore: "schindlers-list",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1993",
        tmdbId: { id: "424", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1982",
      isWinner: false,
      movie: {
        tvdbId: 323,
        name: "Raiders of the Lost Ark",
        tvdbScore: "raiders-of-the-lost-ark",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1981",
        tmdbId: { id: "85", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1968",
      isWinner: false,
      movie: {
        tvdbId: 7580,
        name: "Bonnie and Clyde",
        tvdbScore: "bonnie-and-clyde",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1967",
        tmdbId: { id: "475", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 1238,
        name: "The Big Short",
        tvdbScore: "the-big-short",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "318846", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1999",
      isWinner: false,
      movie: {
        tvdbId: 1681,
        name: "The Thin Red Line",
        tvdbScore: "the-thin-red-line",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1998",
        tmdbId: { id: "8741", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 3349,
        name: "Brooklyn",
        tvdbScore: "brooklyn",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "167073", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2002",
      isWinner: false,
      movie: {
        tvdbId: 107,
        name: "The Lord of the Rings: The Fellowship of the Ring",
        tvdbScore: "the-lord-of-the-rings-the-fellowship-of-the-ring",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "120", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 157,
        name: "The Lord of the Rings: The Two Towers",
        tvdbScore: "the-lord-of-the-rings-the-two-towers",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "121", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: true,
      movie: {
        tvdbId: 331939,
        name: "Everything Everywhere All at Once",
        tvdbScore: "everything-everywhere-all-at-once",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "545611", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2007",
      isWinner: false,
      movie: {
        tvdbId: 6438,
        name: "Little Miss Sunshine",
        tvdbScore: "little-miss-sunshine",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "773", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 134446,
        name: "Elvis",
        tvdbScore: "elvis-2022",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "614934", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1986",
      isWinner: true,
      movie: {
        tvdbId: 4953,
        name: "Out of Africa",
        tvdbScore: "out-of-africa",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1985",
        tmdbId: { id: "606", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1977",
      isWinner: true,
      movie: {
        tvdbId: 531,
        name: "Rocky",
        tvdbScore: "rocky",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1976",
        tmdbId: { id: "1366", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1965",
      isWinner: false,
      movie: {
        tvdbId: 762,
        name: "Mary Poppins",
        tvdbScore: "mary-poppins",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1964",
        tmdbId: { id: "433", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 329,
        name: "Toy Story 3",
        tvdbScore: "toy-story-3",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "10193", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2001",
      isWinner: false,
      movie: {
        tvdbId: 2046,
        name: "卧虎藏龙",
        tvdbScore: "crouching-tiger-hidden-dragon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2000",
        tmdbId: { id: "146", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 57613,
        name: "Ford v Ferrari",
        tvdbScore: "ford-v-ferrari",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "359724", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1971",
      isWinner: false,
      movie: {
        tvdbId: 3723,
        name: "M*A*S*H",
        tvdbScore: "mash",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1970",
        tmdbId: { id: "651", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1929",
      isWinner: false,
      movie: {
        tvdbId: 18821,
        name: "The Crowd",
        tvdbScore: "the-crowd",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1928",
        tmdbId: { id: "3061", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 139,
        name: "La La Land",
        tvdbScore: "la-la-land",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "313369", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1975",
      isWinner: false,
      movie: {
        tvdbId: 2442,
        name: "Chinatown",
        tvdbScore: "chinatown",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1974",
        tmdbId: { id: "829", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1977",
      isWinner: false,
      movie: {
        tvdbId: 4179,
        name: "Network",
        tvdbScore: "network",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1976",
        tmdbId: { id: "10774", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1992",
      isWinner: true,
      movie: {
        tvdbId: 15030,
        name: "The Silence of the Lambs",
        tvdbScore: "the-silence-of-the-lambs",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1991",
        tmdbId: { id: "274", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1976",
      isWinner: false,
      movie: {
        tvdbId: 829,
        name: "Jaws",
        tvdbScore: "jaws",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1975",
        tmdbId: { id: "578", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 7644,
        name: "Joker",
        tvdbScore: "joker",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "475557", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: false,
      movie: {
        tvdbId: 20220,
        name: "Little Women",
        tvdbScore: "little-women-2019",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "331482", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1973",
      isWinner: false,
      movie: {
        tvdbId: 5469,
        name: "Deliverance",
        tvdbScore: "deliverance",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1972",
        tmdbId: { id: "10669", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 1290,
        name: "Silver Linings Playbook",
        tvdbScore: "silver-linings-playbook",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "82693", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1981",
      isWinner: false,
      movie: {
        tvdbId: 3769,
        name: "Tess",
        tvdbScore: "tess",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1979",
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 157720,
        name: "Licorice Pizza",
        tvdbScore: "licorice-pizza",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "718032", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 246288,
        name: "ドライブ・マイ・カー",
        tvdbScore: "246288-",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "758866", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 267783,
        name: "Belfast",
        tvdbScore: "belfast",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "777270", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 192569,
        name: "The Power of the Dog",
        tvdbScore: "the-power-of-the-dog",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "600583", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: true,
      movie: {
        tvdbId: 149849,
        name: "CODA",
        tvdbScore: "coda-2021",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "776503", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1982",
      isWinner: false,
      movie: {
        tvdbId: 12227,
        name: "Atlantic City",
        tvdbScore: "atlantic-city",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1980",
        tmdbId: { id: "23954", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 270,
        name: "Get Out",
        tvdbScore: "get-out",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "419430", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 206782,
        name: "Triangle of Sadness",
        tvdbScore: "triangle-of-sadness",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "497828", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 46012,
        name: "All Quiet on the Western Front",
        tvdbScore: "46012-all-quiet-on-the-western-front",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "49046", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 424,
        name: "Dunkirk",
        tvdbScore: "dunkirk",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "374720", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 113,
        name: "Inception",
        tvdbScore: "inception",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "27205", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: true,
      movie: {
        tvdbId: 41517,
        name: "기생충",
        tvdbScore: "parasite-2019",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "496243", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "1976",
      isWinner: true,
      movie: {
        tvdbId: 785,
        name: "One Flew Over the Cuckoo's Nest",
        tvdbScore: "one-flew-over-the-cuckoos-nest",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "1975",
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 6187,
        name: "Dune",
        tvdbScore: "dune-2021",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "438631", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 1361,
        name: "The Pianist",
        tvdbScore: "the-pianist",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "423", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
  ],
};
//Animated Feature Film - Academy Awards
const category6 = {
  award: { id: 1, name: "Academy Awards" },
  category: {
    id: 6,
    name: "Animated Feature Film",
    forSeries: false,
    forMovies: true,
    overview: "Celebrates excellence in animated filmmaking since 2001.",
  },
  nominees: [
    {
      awardYear: "2002",
      isWinner: false,
      movie: {
        tvdbId: 6245,
        name: "Jimmy Neutron: Boy Genius",
        tvdbScore: "jimmy-neutron-boy-genius",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "12589", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 655,
        name: "Treasure Planet",
        tvdbScore: "treasure-planet",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "9016", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: false,
      movie: {
        tvdbId: 2644,
        name: "Surf's Up",
        tvdbScore: "surfs-up",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 7629,
        name: "The Secret of Kells",
        tvdbScore: "the-secret-of-kells",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "26963", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 14092,
        name: "Chico & Rita",
        tvdbScore: "chico-rita",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "63498", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: true,
      movie: {
        tvdbId: 2334,
        name: "Rango",
        tvdbScore: "rango",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "44896", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 3381,
        name: "The Boxtrolls",
        tvdbScore: "the-boxtrolls",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "170687", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 4969,
        name: "Anomalisa",
        tvdbScore: "anomalisa",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "291270", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 2688,
        name: "Shaun the Sheep Movie",
        tvdbScore: "shaun-the-sheep-movie",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "263109", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 4060,
        name: "Loving Vincent",
        tvdbScore: "loving-vincent",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "339877", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 3514,
        name: "Puss in Boots",
        tvdbScore: "puss-in-boots",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "417859", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 1417,
        name: "Ferdinand",
        tvdbScore: "ferdinand",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "364689", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2012",
      isWinner: false,
      movie: {
        tvdbId: 769,
        name: "Kung Fu Panda 2",
        tvdbScore: "kung-fu-panda-2",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2011",
        tmdbId: { id: "49444", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 501,
        name: "Kubo and the Two Strings",
        tvdbScore: "kubo-and-the-two-strings",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "313297", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 1874,
        name: "ParaNorman",
        tvdbScore: "paranorman",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "77174", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: true,
      movie: {
        tvdbId: 534,
        name: "Ratatouille",
        tvdbScore: "ratatouille",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
        tmdbId: { id: "2062", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2002",
      isWinner: true,
      movie: {
        tvdbId: 325,
        name: "Shrek",
        tvdbScore: "shrek",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "808", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: true,
      movie: {
        tvdbId: 159,
        name: "Inside Out",
        tvdbScore: "inside-out",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2015",
        tmdbId: { id: "150540", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2016",
      isWinner: false,
      movie: {
        tvdbId: 13389,
        name: "O Menino e o Mundo",
        tvdbScore: "boy-the-world",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "223706", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 134511,
        name: "Over the Moon",
        tvdbScore: "134511-over-the-moon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "560050", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 313,
        name: "Isle of Dogs",
        tvdbScore: "isle-of-dogs",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "399174", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 66180,
        name: "Onward",
        tvdbScore: "onward",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "508439", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 7342,
        name: "The Boss Baby",
        tvdbScore: "the-boss-baby",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "295693", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2009",
      isWinner: false,
      movie: {
        tvdbId: 918,
        name: "Bolt",
        tvdbScore: "bolt",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "13053", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: true,
      movie: {
        tvdbId: 263,
        name: "The Incredibles",
        tvdbScore: "the-incredibles",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "9806", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 1068,
        name: "Spirit: Stallion of the Cimarron",
        tvdbScore: "spirit-stallion-of-the-cimarron",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "9023", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 4346,
        name: "Song of the Sea",
        tvdbScore: "song-of-the-sea",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "110416", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 5842,
        name: "Ernest et Célestine",
        tvdbScore: "ernest-celestine",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "126319", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 9681,
        name: "Une Vie de chat",
        tvdbScore: "a-cat-in-paris",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "52264", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 9144,
        name: "A Shaun the Sheep Movie: Farmageddon",
        tvdbScore: "a-shaun-the-sheep-movie-farmageddon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "422803", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 458,
        name: "Ice Age",
        tvdbScore: "ice-age",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
      },
    },
    {
      awardYear: "2007",
      isWinner: true,
      movie: {
        tvdbId: 1466,
        name: "Happy Feet",
        tvdbScore: "happy-feet",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "9836", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 2164,
        name: "未来のミライ",
        tvdbScore: "mirai",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "475215", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 133345,
        name: "The Mitchells vs. The Machines",
        tvdbScore: "the-mitchells-vs-the-machines",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "501929", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2007",
      isWinner: false,
      movie: {
        tvdbId: 2439,
        name: "Monster House",
        tvdbScore: "monster-house",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "9297", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: true,
      movie: {
        tvdbId: 186,
        name: "Brave",
        tvdbScore: "brave",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "62177", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 866,
        name: "The Princess and the Frog",
        tvdbScore: "the-princess-and-the-frog",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "10198", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: true,
      movie: {
        tvdbId: 89,
        name: "Frozen",
        tvdbScore: "frozen",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "109445", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 10577,
        name: "Ma vie de courgette",
        tvdbScore: "my-life-as-a-zucchini",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "393559", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 131415,
        name: "Raya and The Last Dragon",
        tvdbScore: "raya-and-the-last-dragon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "527774", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2020",
      isWinner: true,
      movie: {
        tvdbId: 10792,
        name: "Toy Story 4",
        tvdbScore: "toy-story-4",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2019",
        tmdbId: { id: "301528", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: true,
      movie: {
        tvdbId: 981,
        name: "Wallace & Gromit: The Curse of the Were-Rabbit",
        tvdbScore: "wallace-gromit-the-curse-of-the-were-rabbit",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2005",
        tmdbId: { id: "533", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 6417,
        name: "L'Illusionniste",
        tvdbScore: "the-illusionist-2010",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "41201", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: true,
      movie: {
        tvdbId: 151,
        name: "Big Hero 6",
        tvdbScore: "big-hero-6",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "177572", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: false,
      movie: {
        tvdbId: 6706,
        name: "The Breadwinner",
        tvdbScore: "the-breadwinner",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "435129", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2009",
      isWinner: true,
      movie: {
        tvdbId: 516,
        name: "WALL·E",
        tvdbScore: "walle",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "10681", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: true,
      movie: {
        tvdbId: 315,
        name: "Up",
        tvdbScore: "up",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "14160", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: false,
      movie: {
        tvdbId: 402,
        name: "Shrek 2",
        tvdbScore: "shrek-2",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "809", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 9210,
        name: "Moana",
        tvdbScore: "moana",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "277834", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 1460,
        name: "The Croods",
        tvdbScore: "the-croods",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "49519", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2009",
      isWinner: false,
      movie: {
        tvdbId: 362,
        name: "Kung Fu Panda",
        tvdbScore: "kung-fu-panda",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2008",
        tmdbId: { id: "9502", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 179,
        name: "Despicable Me 2",
        tvdbScore: "despicable-me-2",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "93456", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2007",
      isWinner: false,
      movie: {
        tvdbId: 562,
        name: "Cars",
        tvdbScore: "cars",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2006",
        tmdbId: { id: "920", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2008",
      isWinner: false,
      movie: {
        tvdbId: 6040,
        name: "Persepolis",
        tvdbScore: "persepolis",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2007",
        tmdbId: { id: "2011", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: true,
      movie: {
        tvdbId: 276,
        name: "千と千尋の神隠し",
        tvdbScore: "spirited-away",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "129", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 237,
        name: "Wreck-It Ralph",
        tvdbScore: "wreck-it-ralph",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "82690", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 3,
        name: "Ralph Breaks the Internet",
        tvdbScore: "ralph-breaks-the-internet",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "404368", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 136107,
        name: "Flugt",
        tvdbScore: "flee",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "680813", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 332307,
        name: "The Sea Beast",
        tvdbScore: "332307-the-sea-beast",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "560057", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: true,
      movie: {
        tvdbId: 145454,
        name: "Encanto",
        tvdbScore: "encanto",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "568124", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2018",
      isWinner: true,
      movie: {
        tvdbId: 321,
        name: "Coco",
        tvdbScore: "coco",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2017",
        tmdbId: { id: "354912", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: true,
      movie: {
        tvdbId: 96850,
        name: "Guillermo Del Toro's Pinocchio",
        tvdbScore: "96850-pinocchio",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "555604", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 149,
        name: "How to Train Your Dragon 2",
        tvdbScore: "how-to-train-your-dragon-2",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "82702", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: false,
      movie: {
        tvdbId: 170,
        name: "How to Train Your Dragon",
        tvdbScore: "how-to-train-your-dragon",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "10191", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 68362,
        name: "Puss in Boots: The Last Wish",
        tvdbScore: "puss-in-boots-2-nine-lives-40-thieves",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "315162", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 4922,
        name: "かぐや姫の物語",
        tvdbScore: "the-tale-of-the-princess-kaguya",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "149871", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2015",
      isWinner: false,
      movie: {
        tvdbId: 2588,
        name: "思い出のマーニー",
        tvdbScore: "when-marnie-was-there",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2014",
        tmdbId: { id: "242828", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 336387,
        name: "Marcel the Shell with Shoes On",
        tvdbScore: "336387-marcel-the-shell-with-shoes-on",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "869626", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: true,
      movie: {
        tvdbId: 33,
        name: "Spider-Man: Into the Spider-Verse",
        tvdbScore: "spider-man-into-the-spider-verse",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "324857", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 1395,
        name: "Coraline",
        tvdbScore: "coraline",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "14836", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: false,
      movie: {
        tvdbId: 8097,
        name: "La Tortue rouge",
        tvdbScore: "the-red-turtle",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "337703", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2017",
      isWinner: true,
      movie: {
        tvdbId: 77,
        name: "Zootopia",
        tvdbScore: "zootopia",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2016",
        tmdbId: { id: "269149", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2010",
      isWinner: false,
      movie: {
        tvdbId: 1309,
        name: "Fantastic Mr. Fox",
        tvdbScore: "fantastic-mr-fox",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2009",
        tmdbId: { id: "10315", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2019",
      isWinner: false,
      movie: {
        tvdbId: 49,
        name: "Incredibles 2",
        tvdbScore: "incredibles-2",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2018",
        tmdbId: { id: "260513", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: false,
      movie: {
        tvdbId: 54383,
        name: "Wolfwalkers",
        tvdbScore: "wolfwalkers",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "441130", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: false,
      movie: {
        tvdbId: 573,
        name: "ハウルの動く城",
        tvdbScore: "howls-moving-castle",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "4935", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2014",
      isWinner: false,
      movie: {
        tvdbId: 4111,
        name: "風立ちぬ",
        tvdbScore: "the-wind-rises",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2013",
        tmdbId: { id: "149870", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2011",
      isWinner: true,
      movie: {
        tvdbId: 329,
        name: "Toy Story 3",
        tvdbScore: "toy-story-3",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2010",
        tmdbId: { id: "10193", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2021",
      isWinner: true,
      movie: {
        tvdbId: 131117,
        name: "Soul",
        tvdbScore: "soul-2020",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2020",
        tmdbId: { id: "508442", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2022",
      isWinner: false,
      movie: {
        tvdbId: 137867,
        name: "Luca",
        tvdbScore: "luca-2021",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2021",
        tmdbId: { id: "508943", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2023",
      isWinner: false,
      movie: {
        tvdbId: 146582,
        name: "Turning Red",
        tvdbScore: "turning-red",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2022",
        tmdbId: { id: "508947", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2013",
      isWinner: false,
      movie: {
        tvdbId: 4059,
        name: "Frankenweenie",
        tvdbScore: "frankenweenie",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2012",
        tmdbId: { id: "62214", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2003",
      isWinner: false,
      movie: {
        tvdbId: 864,
        name: "Lilo & Stitch",
        tvdbScore: "lilo-stitch",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2002",
        tmdbId: { id: "11544", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2004",
      isWinner: false,
      movie: {
        tvdbId: 1157,
        name: "Brother Bear",
        tvdbScore: "brother-bear",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
        tmdbId: { id: "10009", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2004",
      isWinner: false,
      movie: {
        tvdbId: 9167,
        name: "Les Triplettes de Belleville",
        tvdbScore: "the-triplets-of-belleville",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
        tmdbId: { id: "9662", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2002",
      isWinner: false,
      movie: {
        tvdbId: 331,
        name: "Monsters, Inc.",
        tvdbScore: "monsters-inc",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2001",
        tmdbId: { id: "585", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2004",
      isWinner: true,
      movie: {
        tvdbId: 256,
        name: "Finding Nemo",
        tvdbScore: "finding-nemo",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2003",
        tmdbId: { id: "12", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2005",
      isWinner: false,
      movie: {
        tvdbId: 763,
        name: "Shark Tale",
        tvdbScore: "shark-tale",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2004",
        tmdbId: { id: "10555", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
    {
      awardYear: "2006",
      isWinner: false,
      movie: {
        tvdbId: 1369,
        name: "Corpse Bride",
        tvdbScore: "corpse-bride",
        status: {
          id: 5,
          name: "Released",
          recordType: "movie",
          keepUpdated: true,
        },
        releaseYear: "2005",
        tmdbId: { id: "3933", type: 10, sourceName: "TheMovieDB.com" },
      },
    },
  ],
};

export const categoryData = [category1, category6];